export default __webpack_public_path__ + "static/media/1.fd6343bf.gif";